"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFieldsForCountry = getFieldsForCountry;
exports.getSchema = getSchema;
exports.getNoSortEdges = getNoSortEdges;
exports.getValidationSchema = getValidationSchema;
exports.getFieldsFromFiles = getFieldsFromFiles;
exports.getValidFileFields = getValidFileFields;
exports.getFieldsWithoutApiFiles = getFieldsWithoutApiFiles;
exports.getOksAndErrorsFromResponse = getOksAndErrorsFromResponse;
exports.getFieldsToUpload = getFieldsToUpload;
exports.getOptionsFromResponseList = getOptionsFromResponseList;
exports.getLabelFromOptionsList = getLabelFromOptionsList;
exports.getLabelFromUserList = getLabelFromUserList;
exports.generateSelectOptionsFromSlugName = generateSelectOptionsFromSlugName;
exports.generateSelectOptions = generateSelectOptions;
exports.inputModeAttrs = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _camelcaseKeys2 = _interopRequireDefault(require("camelcase-keys"));

var _camelCase = _interopRequireDefault(require("lodash/camelCase"));

var _yup = require("yup");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function getFieldsForCountry(_ref) {
  var _ref$countryCode = _ref.countryCode,
      countryCode = _ref$countryCode === void 0 ? null : _ref$countryCode,
      fieldsByCountry = _ref.fieldsByCountry;

  if (!fieldsByCountry) {
    throw new Error('No fieldsByCountry object passed.');
  }

  if (!fieldsByCountry.DEFAULT) {
    throw new Error('The fieldsByCountry object does not have a DEFAULT property.');
  }

  return fieldsByCountry[countryCode] || fieldsByCountry.DEFAULT;
}

function getSchema() {
  var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var newSchema = {};
  fields.forEach(function (field) {
    if (field.schema) {
      newSchema[field.name] = field.schema;
    }
  });
  return newSchema;
} // noSortEdges is the second parameter of shape() and ignores the order of the specified field names
// so that the field order does not matter whem a field relies on another one via when()
// Docs https://github.com/jquense/yup#objectshapefields-object-nosortedges-arraystring-string-schema
// Explanation https://gitmemory.com/issue/jquense/yup/720/564591045


function getNoSortEdges() {
  var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return fields.reduce(function (list, field) {
    if (field.noSortEdges) {
      list.push(field.name);
    }

    return list;
  }, []);
}

function getValidationSchema(_ref2) {
  var _ref2$fields = _ref2.fields,
      fields = _ref2$fields === void 0 ? [] : _ref2$fields;
  return (0, _yup.object)().shape(getSchema(fields), getNoSortEdges(fields));
}

function getFieldsFromFiles(arrayOfFiles) {
  return arrayOfFiles.reduce(function (output, file) {
    // Ignore null subType
    if (!file.subType) {
      return output;
    }

    var normalizedSubType = (0, _camelCase["default"])(file.subType);
    var existingFiles = output[normalizedSubType] || [];
    existingFiles.push(file);
    output[normalizedSubType] = existingFiles;
    return output;
  }, {});
}

function getValidFileFields(fields) {
  // If the value is a string, its not valid
  // If is an array or undefined, its valid
  return Object.entries(fields).reduce(function (validFields, _ref3) {
    var _ref4 = (0, _slicedToArray2["default"])(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    if (typeof value !== 'string') {
      validFields[key] = value;
    }

    return validFields;
  }, {});
}

function getFieldsWithoutApiFiles(fields) {
  return Object.entries(fields).reduce(function (output, _ref5) {
    var _ref6 = (0, _slicedToArray2["default"])(_ref5, 2),
        key = _ref6[0],
        _ref6$ = _ref6[1],
        files = _ref6$ === void 0 ? [] : _ref6$;

    var filesWithoutSlug = files.filter(function (file) {
      return !file.slug;
    });

    if (filesWithoutSlug.length > 0) {
      output[key] = filesWithoutSlug;
    }

    return output;
  }, {});
}

function getOksAndErrorsFromResponse(response) {
  var _camelcaseKeys = (0, _camelcaseKeys2["default"])(response, {
    deep: true
  }),
      data = _camelcaseKeys.data;

  var keys = Object.keys(data);
  var result = {
    oks: [],
    errors: []
  };
  keys.forEach(function (key) {
    var processedField = _objectSpread({
      fieldName: key
    }, data[key]);

    var target = data[key].status === 'error' ? 'errors' : 'oks';
    result[target].push(processedField);
  });
  return result;
}

function getFieldsToUpload(fields, alreadyUploadedFields) {
  var keys = Object.keys(fields);
  var result = {};
  keys.forEach(function (key) {
    if (!alreadyUploadedFields.includes(key)) {
      result[key] = fields[key];
    }
  });
  return result;
}

function getOptionsFromResponseList(list) {
  return list.map(function (_ref7) {
    var slug = _ref7.slug,
        name = _ref7.name;
    return {
      value: slug,
      label: name
    };
  });
}

function getLabelFromOptionsList(list, matchSlug) {
  var _list$find;

  return list === null || list === void 0 ? void 0 : (_list$find = list.find(function (_ref8) {
    var value = _ref8.value;
    return value === matchSlug;
  })) === null || _list$find === void 0 ? void 0 : _list$find.label;
}

function getLabelFromUserList(list, matchSlug) {
  var _list$find2;

  return list === null || list === void 0 ? void 0 : (_list$find2 = list.find(function (_ref9) {
    var slug = _ref9.slug;
    return slug === matchSlug;
  })) === null || _list$find2 === void 0 ? void 0 : _list$find2.name;
}

function generateSelectOptionsFromSlugName(list) {
  if (!list || list.length === 0) return [];
  return list.map(function (_ref10) {
    var slug = _ref10.slug,
        name = _ref10.name;
    return {
      value: slug,
      label: name
    };
  });
}

function generateSelectOptions(list) {
  return Object.entries(list).map(function (_ref11) {
    var _ref12 = (0, _slicedToArray2["default"])(_ref11, 2),
        value = _ref12[0],
        label = _ref12[1];

    return {
      value: value,
      label: label
    };
  });
}
/**
 * Do not use type="number", it has A11Y and UX issues.
  Prefer using inputmode attribute
  https://technology.blog.gov.uk/2020/02/24/why-the-gov-uk-design-system-team-changed-the-input-type-for-numbers/
  https://css-tricks.com/everything-you-ever-wanted-to-know-about-inputmode/
  */


var inputModeAttrs = {
  type: 'text',
  inputMode: 'decimal',
  pattern: '^[0-9.]*$' // accepts numbers and dots (eg 10, 15.50)

};
exports.inputModeAttrs = inputModeAttrs;